module.exports = __webpack_public_path__ + "static/media/Plumbing.73400e33.jpeg";